export default __webpack_public_path__ + "static/media/tech-value.05e300a7.jpeg";